import Button from "atoms/buttons/button";
import React from "react";
import TextAreaFormField from "molecules/form-fields/text-area-form-field";
import { StringUtils } from "@rsm-hcd/javascript-core";
import { t } from "utilities/localization-utils";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

export interface ManageTeamInviteFieldProps {
    emailError?: string;
    handleOnChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    inviteEmail: string;
    handleAddClick: () => void;
    totalSeatsRemaining: number;
    totalExistingMembers?: number;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const CLASS_NAME = "c-manage-team-settings";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const ManageTeamInviteField: React.FC<ManageTeamInviteFieldProps> = ({
    emailError,
    handleOnChange,
    inviteEmail,
    handleAddClick,
    totalSeatsRemaining,
    totalExistingMembers,
}) => {
    const unableToAddMoreSeats = totalSeatsRemaining <= 0;
    const totalInvitesToRemove =
        totalSeatsRemaining < 0 ? Math.abs(totalSeatsRemaining) : 0;
    const mustRemoveInvitesOrMembers = totalInvitesToRemove > 0;

    return (
        <div className={`${CLASS_NAME}__content`}>
            {mustRemoveInvitesOrMembers && (
                <div
                    className={`${CLASS_NAME}__content__warning`}
                    data-test-id="mustRemoveMembersWarning">
                    {t("youHaveTo")}
                    <strong>
                        {totalInvitesToRemove === 1
                            ? t("removeInvitesToRemoveMember", {
                                  invitesToRemove: totalInvitesToRemove,
                              })
                            : t("removeInvitesToRemoveMembers", {
                                  invitesToRemove: totalInvitesToRemove,
                              })}
                    </strong>
                    {t("forYourCurrentSubscription")}
                </div>
            )}
            <div
                className={`${CLASS_NAME}__content__email${
                    StringUtils.hasValue(emailError) ? " -invalid" : ""
                }`}>
                <TextAreaFormField
                    inputTestId="emailToInvite"
                    disabled={unableToAddMoreSeats}
                    errorMessage={emailError}
                    isValid={StringUtils.isEmpty(emailError)}
                    label={""}
                    placeholder={t("teamInvitePlaceholder")}
                    onChange={handleOnChange}
                    helperText={
                        <>
                            <strong data-test-id="seatsRemainingHelperText">
                                {totalSeatsRemaining === 1
                                    ? t("seatsRemaining_single", {
                                          count: totalSeatsRemaining,
                                      })
                                    : t("seatsRemaining_plural", {
                                          count: totalSeatsRemaining,
                                      })}
                            </strong>
                            {totalExistingMembers &&
                                totalExistingMembers > 0 && (
                                    <span>
                                        {" "}
                                        ({totalExistingMembers} on the team
                                        already).{" "}
                                    </span>
                                )}
                            {t("groupInvite-invitationInputHelperText")}
                        </>
                    }
                    rows={1}
                    value={inviteEmail}
                />
                <Button
                    disabled={unableToAddMoreSeats}
                    onClick={() => handleAddClick()}>
                    {t("add")}
                </Button>
            </div>
        </div>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default ManageTeamInviteField;

// #endregion Exports
